module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-layout"
  }, [_c('header', {
    staticClass: "app-header cf"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('a', {
    staticClass: "app-logo",
    attrs: {
      "href": "/home"
    }
  }, [_c('h1', [_vm._v("分享收客")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('ul', {
    staticClass: "app-nav fl-l"
  }, [_c('li', [_c('router-link', {
    class: {
      active: _vm.isActive('/index')
    },
    attrs: {
      "to": "/index"
    }
  }, [_vm._v("首页")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive('/share')
    },
    attrs: {
      "to": "/share"
    }
  }, [_vm._v("内容管理")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive('/ad')
    },
    attrs: {
      "to": "/ad"
    }
  }, [_vm._v("精准营销")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "app-userInfo fl-r"
  }, [(!_vm.user) ? _c('span', [_c('el-button', {
    staticClass: "app-orang",
    nativeOn: {
      "click": function($event) {
        return _vm.experienceLogin($event)
      }
    }
  }, [_vm._v("立即体验")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.login($event)
      }
    }
  }, [_vm._v("登录")])], 1) : _c('span', [_vm._v("\n              您好，" + _vm._s(_vm.user.realname || _vm.user.username) + "\n              "), _c('small', {
    staticStyle: {
      "color": "#00BCD4"
    }
  }, [_vm._v("(" + _vm._s(_vm.user.type_) + ")")]), _vm._v(" "), _c('span', {
    staticClass: "pl-xs pr-xs",
    staticStyle: {
      "color": "#ccc"
    }
  }, [_vm._v("|")]), _vm._v(" "), _c('el-button', {
    staticClass: "ml-s",
    attrs: {
      "type": "info",
      "size": "mini"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.back($event)
      }
    }
  }, [_vm._v("进入可可兔")]), _vm._v(" "), _c('el-button', {
    staticClass: "ml-s",
    attrs: {
      "type": "success",
      "size": "mini"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.login($event)
      }
    }
  }, [_vm._v("退出")])], 1)])])], 1)], 1)]), _vm._v(" "), _c('main', {
    staticClass: "app-main cf"
  }, [_c('router-view')], 1), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "app-footer"
  }, [_c('p', [_vm._v("Copyright(©) 2017 www.keketour.com 深圳市众游汇网络科技有限公司 All Rights Re")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://szcert.ebs.org.cn/CF52D6F1-F06A-4BEE-BD73-D7C41700F938",
      "target": "__blank"
    }
  }, [_c('img', {
    staticClass: "app-footer__",
    attrs: {
      "src": require("./img/bureau.jpg")
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-1b124a8a!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/layout.vue
// module id = 217
// module chunks = 29